<template>
  <PageWrapper>
    <div class="error404">
      This page is not available
    </div>
  </PageWrapper>
</template>

<script>
import PageWrapper from '../components/PageWrapper.vue';

export default {
  components: {
    PageWrapper,
  },
};
</script>

<style scoped>
.error404 {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 40px;
}
</style>
